function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradingBankAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 250,
    style: {
      fill: "#2e2447"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.98,
    y: 244.66,
    width: 33.34,
    height: 91.15,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 11
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "167.9 219.5 167.9 244.66 115.41 244.66 115.41 219.5",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 11
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.82,
    y: 335.81,
    width: 83.67,
    height: 25.16,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 11
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.81,
    y: 244.66,
    width: 33.34,
    height: 91.15,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 11
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "276.73 219.5 276.73 244.66 224.24 244.66 224.24 219.5",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 11
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.65,
    y: 335.81,
    width: 83.67,
    height: 25.16,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 11
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.24,
    y: 360.97,
    width: 326.75,
    height: 25.16,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 11
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.64,
    y: 244.66,
    width: 33.34,
    height: 91.15,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 11
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "385.56 219.5 385.56 244.66 333.07 244.66 333.07 219.5",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 11
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.48,
    y: 335.81,
    width: 83.67,
    height: 25.16,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 11
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "401.41 191.61 401.41 216.77 99.56 216.77 99.56 191.61",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 11
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.91 166.45 413.91 191.61 87.06 191.61 87.06 166.45 250.49 82.56 413.91 166.45",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 11
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.28,
    y1: 118.46,
    x2: 250.28,
    y2: 105.88,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 11
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.28,
    y1: 175.35,
    x2: 250.28,
    y2: 162.77,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 11
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.28,140.62c6.73,0,12.18,5,12.18,11.07s-5.45,11.08-12.18,11.08-12.17-5-12.17-11.08",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 11
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.28,140.62c-6.72,0-12.17-5-12.17-11.08s5.45-11.08,12.17-11.08,12.18,5,12.18,11.08",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 11
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.03,
    y1: 140.62,
    x2: 300.61,
    y2: 140.62,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 11
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.36,
    y1: 140.62,
    x2: 212.94,
    y2: 140.62,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 11
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 426.57,
    y1: 386.14,
    x2: 74.66,
    y2: 386.14,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 11
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingBankAccountIcon);
export default __webpack_public_path__ + "static/media/trading-bank-account-icon.e680ce75e1199279c346373d90d5b08d.svg";
export { ForwardRef as ReactComponent };